import { Alert, AlertTitle } from '@mui/material';
import React, { FC } from 'react';

const MUIAlert: FC<{ infoType?: 'success' | 'info' | 'warning' | 'error'; title?: string; message: string }> = ({
	infoType = 'info',
	title,
	message,
}) => {
	return (
		<Alert severity={infoType}>
			{title && <AlertTitle>{title}</AlertTitle>}
			{message}
		</Alert>
	);
};
export default MUIAlert;
